var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-logo-wrapper"},[_c('div',{staticClass:"client-logo",style:(("background-image: url('" + _vm.logoUrl + "');"))})])}
var staticRenderFns = []

export { render, staticRenderFns }